export default "__VITE_ASSET__0FsadDTN__"